import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import API_BASE_URL from '../api';

const ICONS = {
    constituency: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>,
    party: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>,
    department: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>,
    add: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
    search: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
};

const THEME = {
    primary: '#C0722C',
    secondary: '#2C1A10',
    accent: '#EAD7BB',
    bg: '#FDF8F3',
    white: '#FFFFFF',
    border: '#F0E8DB'
};

const MasterDataManagement = () => {
    const [activeTab, setActiveTab] = useState('constituencies');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const { data: res } = await axios.get(`${API_BASE_URL}/api/master/${activeTab}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setData(res);
        } catch (err) {
            console.error("Registry sync failed", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [activeTab]);

    const handleAdd = async () => {
        let title, htmlContent;

        if (activeTab === 'constituencies') {
            title = 'New Constituency';
            htmlContent = `
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Constituency Name</div>
                <input id="swal-input-name" class="swal2-input custom-input" placeholder="e.g. Patliputra" style="margin: 0 0 15px 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Constituency Code (Required)</div>
                <input id="swal-input-extra" class="swal2-input custom-input" placeholder="e.g. PAT-001" style="margin: 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-top: 5px; font-size: 11px; color: #999;">Format: 3 Letters - 3 Digits (e.g. PAT-001)</div>
            `;
        } else if (activeTab === 'parties') {
            title = 'New Political Party';
            htmlContent = `
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Party Name</div>
                <input id="swal-input-name" class="swal2-input custom-input" placeholder="e.g. JDU" style="margin: 0 0 15px 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Party Leader (Optional)</div>
                <input id="swal-input-extra" class="swal2-input custom-input" placeholder="Name of Leader" style="margin: 0; width: 100%; box-sizing: border-box;">
            `;
        } else {
            title = 'New Department';
            htmlContent = `
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Department Name</div>
                <input id="swal-input-name" class="swal2-input custom-input" placeholder="e.g. Finance" style="margin: 0 0 15px 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Department Head (Optional)</div>
                <input id="swal-input-extra" class="swal2-input custom-input" placeholder="Head of Department" style="margin: 0; width: 100%; box-sizing: border-box;">
            `;
        }

        const { value: formValues } = await Swal.fire({
            title: `<span style="font-family: 'Outfit', font-weight: 800; color: ${THEME.secondary}">${title}</span>`,
            html: htmlContent,
            showCancelButton: true,
            confirmButtonColor: THEME.secondary,
            confirmButtonText: 'Commit to Ledger',
            cancelButtonColor: '#d33',
            background: THEME.bg,
            color: THEME.text,
            width: '450px',
            padding: '2em',
            customClass: { popup: 'glass-modal' },
            focusConfirm: false,
            preConfirm: () => {
                const name = document.getElementById('swal-input-name').value;
                const extra = document.getElementById('swal-input-extra').value;

                if (!name) Swal.showValidationMessage('Name is mandatory');
                if (activeTab === 'constituencies' && !extra) Swal.showValidationMessage('Constituency Code is mandatory');

                return { name, extra };
            }
        });

        if (formValues) {
            // Unpack values based on tab
            const payload = { name: formValues.name };
            if (activeTab === 'constituencies') payload.code = formValues.extra;
            else if (activeTab === 'parties') payload.leader = formValues.extra;
            else if (activeTab === 'departments') payload.head = formValues.extra;

            // Show Loading
            Swal.fire({
                title: 'Synchronizing Ledger...',
                text: 'Committing new entry to the immutable registry.',
                allowOutsideClick: false,
                didOpen: () => { Swal.showLoading(); }
            });

            try {
                const token = localStorage.getItem('token');
                await axios.post(`${API_BASE_URL}/api/master/${activeTab}`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.fire({
                    title: '<span style="font-family: \'Outfit\', font-weight: 800; font-size: 20px;">Protocol Success</span>',
                    text: 'Master registry has been synchronized.',
                    icon: 'success',
                    confirmButtonColor: THEME.primary,
                    borderRadius: '24px'
                });
                fetchData();
            } catch (err) {
                // Determine error message
                const msg = err.response?.data?.error || 'Entry already exists or validation failed.';
                Swal.fire({
                    title: 'Conflict Detected',
                    text: msg,
                    icon: 'error',
                    confirmButtonColor: THEME.secondary
                });
            }
        }
    };

    const handleEdit = async (item) => {
        let title, htmlContent;
        const isConst = activeTab === 'constituencies';
        const isParty = activeTab === 'parties';
        const isDept = activeTab === 'departments';

        if (isConst) {
            title = 'Edit Constituency';
            htmlContent = `
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Constituency Name</div>
                <input id="swal-edit-name" value="${item.name}" class="swal2-input custom-input" style="margin: 0 0 15px 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Constituency Code</div>
                <input id="swal-edit-extra" value="${item.code || ''}" class="swal2-input custom-input" style="margin: 0; width: 100%; box-sizing: border-box;">
            `;
        } else if (isParty) {
            title = 'Edit Political Party';
            htmlContent = `
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Party Name</div>
                <input id="swal-edit-name" value="${item.name}" class="swal2-input custom-input" style="margin: 0 0 15px 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Party Leader (Optional)</div>
                <input id="swal-edit-extra" value="${item.leader || ''}" class="swal2-input custom-input" style="margin: 0; width: 100%; box-sizing: border-box;">
            `;
        } else {
            title = 'Edit Department';
            htmlContent = `
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Department Name</div>
                <input id="swal-edit-name" value="${item.name}" class="swal2-input custom-input" style="margin: 0 0 15px 0; width: 100%; box-sizing: border-box;">
                <div style="text-align: left; margin-bottom: 5px; font-weight: 600; color: #666; font-size: 13px;">Department Head (Optional)</div>
                <input id="swal-edit-extra" value="${item.head || ''}" class="swal2-input custom-input" style="margin: 0; width: 100%; box-sizing: border-box;">
            `;
        }

        const { value: formValues } = await Swal.fire({
            title: `<span style="font-family: 'Outfit', font-weight: 800; color: ${THEME.secondary}">${title}</span>`,
            html: htmlContent,
            showCancelButton: true,
            confirmButtonColor: THEME.primary,
            confirmButtonText: 'Update Entry',
            cancelButtonColor: '#d33',
            background: THEME.bg,
            color: THEME.text,
            width: '450px',
            padding: '2em',
            customClass: { popup: 'glass-modal' },
            focusConfirm: false,
            preConfirm: () => {
                const name = document.getElementById('swal-edit-name').value;
                const extra = document.getElementById('swal-edit-extra').value;
                if (!name) Swal.showValidationMessage('Name is mandatory');
                if (isConst && !extra) Swal.showValidationMessage('Code is mandatory');
                return { name, extra };
            }
        });

        if (formValues) {
            const payload = { name: formValues.name };
            if (isConst) payload.code = formValues.extra;
            else if (isParty) payload.leader = formValues.extra;
            else if (isDept) payload.head = formValues.extra;

            try {
                const token = localStorage.getItem('token');
                await axios.put(`${API_BASE_URL}/api/master/${activeTab}/${item._id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.fire('Updated', 'Registry entry has been updated.', 'success');
                fetchData();
            } catch (err) {
                Swal.fire('Error', err.response?.data?.error || 'Update failed', 'error');
            }
        }
    };

    const handleDelete = async (item) => {
        const result = await Swal.fire({
            title: 'Confirm Deactivation',
            text: `Are you sure you want to deactivate "${item.name}"? This will restrict usage in new profiles.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D32F2F',
            cancelButtonColor: THEME.secondary,
            confirmButtonText: 'Yes, Deactivate',
            background: THEME.bg
        });

        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`${API_BASE_URL}/api/master/${activeTab}/${item._id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                Swal.fire('Deactivated', 'Entry has been deactivated.', 'success');
                fetchData();
            } catch (err) {
                Swal.fire('Error', 'Deactivation failed', 'error');
            }
        }
    };

    const toggleStatus = async (item) => {
        try {
            const token = localStorage.getItem('token');
            await axios.patch(`${API_BASE_URL}/api/master/${activeTab}/${item._id}/status`,
                { isActive: !item.isActive },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            fetchData();
        } catch (err) {
            Swal.fire('Protocol Error', 'Unable to modify registry state.', 'error');
        }
    };

    const handleRestore = async (item) => {
        toggleStatus(item);
    };

    const tabs = [
        { id: 'constituencies', label: 'Electoral Regions', icon: ICONS.constituency },
        { id: 'parties', label: 'Entity Assets', icon: ICONS.party },
        { id: 'departments', label: 'Executive Pulse', icon: ICONS.department },
    ];

    const filteredData = data.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item._id.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div style={{ maxWidth: '1400px', margin: '0 auto', fontFamily: "'Outfit', sans-serif" }}>
            {/* Header Section */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '45px' }}>
                <div>
                    <h1 style={{ margin: '0 0 10px 0', fontSize: '32px', fontWeight: '800', color: THEME.secondary, letterSpacing: '-1px' }}>
                        Core Infrastructure Registry
                    </h1>
                    <p style={{ margin: 0, color: '#999', fontSize: '16px', fontWeight: '500' }}>
                        Centralized governance of state electoral and executive master data.
                    </p>
                </div>
                <button
                    onClick={handleAdd}
                    style={{
                        padding: '18px 35px',
                        backgroundColor: THEME.primary,
                        color: THEME.white,
                        border: 'none',
                        borderRadius: '18px',
                        fontWeight: '800',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        boxShadow: '0 12px 30px rgba(192, 114, 44, 0.25)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                    }}
                    onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 15px 35px rgba(192, 114, 44, 0.35)'; }}
                    onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 12px 30px rgba(192, 114, 44, 0.25)'; }}
                >
                    {ICONS.add}
                    Initialize Entry
                </button>
            </div>

            {/* Utility Bar */}
            <div style={{ display: 'flex', gap: '25px', marginBottom: '35px', alignItems: 'center', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', gap: '12px', background: '#fff', padding: '10px', borderRadius: '22px', border: `1px solid ${THEME.border}`, flex: '2 1 600px', minWidth: '400px' }}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            style={{
                                padding: '14px 28px',
                                background: activeTab === tab.id ? THEME.secondary : 'transparent',
                                color: activeTab === tab.id ? THEME.accent : '#888',
                                border: 'none',
                                borderRadius: '16px',
                                cursor: 'pointer',
                                fontWeight: '700',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            {tab.icon}
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div style={{ position: 'relative', flex: '1 1 450px', maxWidth: '600px', minWidth: '300px' }}>
                    <span style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', color: THEME.primary, zIndex: 2, display: 'flex' }}>
                        {ICONS.search}
                    </span>
                    <input
                        type="text"
                        placeholder="Scan ledger records..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="custom-input"
                        style={{
                            paddingLeft: '55px',
                            borderRadius: '22px',
                            boxShadow: '0 5px 15px rgba(0,0,0,0.02)',
                            height: '56px',
                            fontWeight: '600'
                        }}
                    />
                </div>
            </div>

            {/* Masterpiece Table */}
            <div style={{ background: THEME.white, borderRadius: '32px', border: `1px solid ${THEME.border}`, overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.03)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ background: THEME.bg }}>
                        <tr>
                            <th style={{ padding: '25px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Official Designation</th>
                            <th style={{ padding: '25px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Cryptographic Hash</th>
                            <th style={{ padding: '25px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Ledger Status</th>
                            <th style={{ padding: '25px 40px', textAlign: 'right', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Directive</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="4" style={{ padding: '80px', textAlign: 'center', color: '#C0722C', fontWeight: '700' }}>Synchronizing with Mainframe...</td></tr>
                        ) : filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="4" style={{ padding: '100px 40px', textAlign: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '25px' }}>
                                        <div style={{ width: '90px', height: '90px', backgroundColor: THEME.bg, borderRadius: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: THEME.primary, opacity: 0.7 }}>
                                            <svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /><path d="M10 7v6m-3-3h6" /></svg>
                                        </div>
                                        <div>
                                            <h3 style={{ margin: '0 0 10px 0', fontSize: '22px', fontWeight: '800', color: THEME.secondary }}>No Matching Records Found</h3>
                                            <p style={{ margin: 0, color: '#999', fontSize: '16px', fontWeight: '500' }}>We couldn't find any entries in the ledger matching your search criteria.</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredData.map((item, idx) => (
                                <tr key={item._id} style={{ borderBottom: idx === filteredData.length - 1 ? 'none' : `1.5px solid ${THEME.bg}`, transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = '#FDFDFD'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
                                    <td style={{ padding: '25px 40px', fontSize: '17px', fontWeight: '800', color: THEME.secondary }}>{item.name}</td>
                                    <td style={{ padding: '25px 40px', fontFamily: '"Roboto Mono", monospace', fontSize: '13px', color: '#999', opacity: 0.8 }}>{item._id}</td>
                                    <td style={{ padding: '25px 40px' }}>
                                        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '10px 18px', background: item.isActive ? '#EEF7EF' : '#FEF2F2', borderRadius: '14px' }}>
                                            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: item.isActive ? '#2E7D32' : '#D32F2F' }} />
                                            <span style={{ fontSize: '12px', fontWeight: '900', color: item.isActive ? '#2E7D32' : '#D32F2F', textTransform: 'uppercase' }}>
                                                {item.isActive ? 'Verified' : 'Deactivated'}
                                            </span>
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 40px', textAlign: 'right' }}>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                            <button
                                                onClick={() => handleEdit(item)}
                                                style={{
                                                    padding: '10px 14px',
                                                    backgroundColor: '#FFF8E1',
                                                    color: '#F57F17',
                                                    border: '1px solid #FFECB3',
                                                    borderRadius: '10px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s'
                                                }}
                                                title="Edit Entry"
                                            >
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                                            </button>

                                            {item.isActive ? (
                                                <button
                                                    onClick={() => handleDelete(item)}
                                                    style={{
                                                        padding: '10px 14px',
                                                        backgroundColor: '#FFEBEE',
                                                        color: '#D32F2F',
                                                        border: '1px solid #FFCDD2',
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s'
                                                    }}
                                                    title="Deactivate Entry"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => handleRestore(item)}
                                                    style={{
                                                        padding: '10px 14px',
                                                        backgroundColor: '#E8F5E9',
                                                        color: '#2E7D32',
                                                        border: '1px solid #C8E6C9',
                                                        borderRadius: '10px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s'
                                                    }}
                                                    title="Restore Entry"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path></svg>
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MasterDataManagement;
